import React, { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const TournamentContext = createContext(null);

export const TournamentProvider = ({ children }) => {
  const [tournaments, setTournaments] = useState([]);
  const [activeId, setActiveId] = useState(localStorage.getItem("active_tournament") || null);
  const [loading, setLoading] = useState(true);

  const load = async () => {
    setLoading(true);
    try {
      const { data } = await api.get("/tournaments");
      setTournaments(data);
      if (data.length && !data.find((t) => t.tournament_id === activeId)) {
        // Default to the Premier League tournament when the user has no stored
        // preference; fall back to the first league-format tournament, then the first.
        const preferred =
          data.find((t) => (t.short_code || "").toUpperCase() === "PL26") ||
          data.find((t) => t.format === "league") ||
          data[0];
        const id = preferred.tournament_id;
        setActiveId(id);
        localStorage.setItem("active_tournament", id);
      }
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { load(); }, []);

  const setActive = (id) => {
    setActiveId(id);
    localStorage.setItem("active_tournament", id);
  };

  const active = tournaments.find((t) => t.tournament_id === activeId) || tournaments[0] || null;

  return (
    <TournamentContext.Provider value={{ tournaments, active, activeId: active?.tournament_id, setActive, refresh: load, loading }}>
      {children}
    </TournamentContext.Provider>
  );
};

export const useTournament = () => useContext(TournamentContext);
